import { useEffect, useState } from 'react';

const svgCache = new Map<string, string>();

type SvgAssetProps = {
    className?: string;
    src: string;
    title?: string;
};

export default function SvgAsset({ className, src, title }: SvgAssetProps) {
    const [markup, setMarkup] = useState(() => svgCache.get(src) || '');
    const classNames = ['svg-asset', className].filter(Boolean).join(' ');

    useEffect(() => {
        let active = true;
        const cached = svgCache.get(src);

        if (cached) {
            setMarkup(cached);
            return () => {
                active = false;
            };
        }

        fetch(src)
            .then((response) => {
                if (!response.ok) throw new Error(`Failed to load SVG asset: ${src}`);
                return response.text();
            })
            .then((svg) => {
                svgCache.set(src, svg);
                if (active) setMarkup(svg);
            })
            .catch(() => {
                if (active) setMarkup('');
            });

        return () => {
            active = false;
        };
    }, [src]);

    return (
        <span
            aria-hidden={title ? undefined : true}
            aria-label={title}
            className={classNames}
            role={title ? 'img' : undefined}
            dangerouslySetInnerHTML={{ __html: markup }}
        />
    );
}
